import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { AccStatus } from 'entities/account/model/types';
import { VerificationStatus } from 'entities/user/model/types';
import { COLORS } from 'shared/const/theme';

export const VERIFICATION_MODAL_DATA: Record<
  VerificationStatus,
  { title: string; text: string; type: string }
> = {
  [VerificationStatus.Rejected]: {
    title: 'emi.verification.rejected.title',
    text: 'emi.verification.rejected.description',
    type: 'error'
  },
  [VerificationStatus.Init]: {
    title: '',
    text: '',
    type: 'info'
  },
  [VerificationStatus.Pending]: {
    title: 'emi.verification.pending.title',
    text: 'emi.verification.pending.description',
    type: 'info'
  },
  [VerificationStatus.Verified]: {
    title: 'emi.verification.verified.title',
    text: 'emi.verification.verified.description',
    type: 'success'
  },
  [VerificationStatus.Completed]: {
    title: 'emi.verification.verified.title',
    text: 'emi.verification.verified.description',
    type: 'success'
  }
};

export const accountStatusMapping: Record<
  AccStatus,
  { title: string; Icon: () => React.ReactNode }
> = {
  [AccStatus.Inactive]: {
    title: 'verification.account.status.new',
    Icon: () => <ExclamationCircleOutlined style={{ color: COLORS.INFO, fontSize: 18 }} />
  },
  [AccStatus.Active]: {
    title: 'verification.account.status.new',
    Icon: () => <CheckCircleOutlined style={{ color: COLORS.INFO, fontSize: 18 }} />
  },
  [AccStatus.Closed]: {
    title: 'verification.account.status.closed',
    Icon: () => <CloseCircleOutlined style={{ color: COLORS.ERROR, fontSize: 18 }} />
  }
} as const;


export const CAN_ADD_ACCOUNT_LIMIT = 5;